var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.slot,{tag:"component",attrs:{"index":_vm.index}})}
var staticRenderFns = []

export { render, staticRenderFns }